module.exports = {
  "下载":"Herunterladen",
  "打开":"Öffnen",
  language: {
    "name":"简体中文",
    "title":"选择语言",
    subList: [
      {
        name:"English",
        link:"en",
      },
      // {
      //   name:"简体中文",
      //   link:"zh",
      // },
      {
          name:"繁體中文",
          link:"tw",
      },
      {
        name:"日本語",
        link:"jp",
      },
      {
        name:"한국어",
        link:"kr",
      },
      {
        name:"ไทย",
        link:"th",
      },
      {
        name:"Tiếng Việt",
        link:"vn",
      },
      {
        name:"Español",
        link:"es",
      },
      {
        name: 'Deutsch',
        link: 'de',
      },
      {
        name: 'Français',
        link: 'fr',
      },
      {
        name: 'Italia',
        link: 'it',
      },
      {
        name: 'Portugal',
        link: 'pt',
      },
      {
        name: 'Расея',
        link: 'ru',
      },
      {
        name: 'عربي',
        link: 'ar',
      },
    ]
  },
  "user":{//my
    "wdtd":"Mein Team",
    "wdyj":"Meine Leistung",
    "ren":"Person",
  },
  "kjsy": {
    "title":"Umsatz",
    "fxsy":"Umsatz teilen",
    "zjlsl":"Gesamtbetrag der Belohnung",
    "jl":"Belohnung",
    "sj":"Datum",
    "sl":"Menge",
    "sm":"Beschreibung",
  },
  pay:{//purchase
    "title":"Mining-Maschine kaufen",
    "gmsl":"Kaufmenge",
    "zf":"Zahlung",
    "kyye":"Verfügbares Guthaben",
    "kyyebz":"Nicht ausreichend verfügbares Guthaben",
    "bztbtips":"Der eingegebene Auszahlungsbetrag ist geringer als die Mindestauszahlungsanforderung dieser Währung",
    "bztbtips2":"Der Auszahlungsbetrag kann nicht niedriger sein als die Mindestauszahlung",
    "qsrjymm":"Bitte geben Sie ein 6-stelliges Transaktionspasswort ein",
    "wxts":"Erinnerung",
  },
  chongbi:{
    "title":"Einzahlung",
    "lianmc":"Kettentyp",
    "scl":"Exklusive Kette generieren",
    "sy":"Privater Schlüssel",
    "ewm":"QR-Code",
    "bcewm":"QR-Code speichern",
    "cbdz":"Einzahlungsadresse",
    "fz":"Kopieren",
    "sl":"Einzahlungsbetrag",
    "qsrsl":"Bitte geben Sie den Einzahlungsbetrag ein",
    "sjczje":"Tatsächlicher Aufladebetrag",
    "qsrsjczje":"Bitte geben Sie den tatsächlichen Aufladebetrag ein",
    "pzms":"Zertifikatsbeschreibung",
    "qsrms":"Bitte geben Sie eine Beschreibung ein",
    "hxz":"Hash-Wert",
    "qsrhxz":"Bitte geben Sie den Hash-Wert ein",
    "pztp":"Gutscheinbild",
    "qscpztp":"Bitte laden Sie das Zertifikatsbild hoch",
    "fzcg":"Kopieren erfolgreich",
    "yhkcz":"Bankkartenaufladung",
    "usdtcz":"USDT-Aufladung",
    "btccz":"BTC-Aufladung",
    "xzbz":"Währung auswählen",
    "sure":"Bestätigen",
    "ck":"Anzeigen",
    "tips1":"Bitte laden Sie keine Vermögenswerte, die nicht in dieser Währung sind, auf die oben genannte Adresse hoch, da die Vermögenswerte sonst nicht abgerufen werden können.",
    "tips2":"1. Ihr Sendenetzwerk und die Zielplattform sind konsistent. Wenn Sie das Ethereum-Netzwerk als Zieladresse wählen, müssen Sie beim Senden die entsprechende Smart Chain auswählen. Bei einem Fehler können Sie Ihre digitalen Vermögenswerte nicht abrufen.",
    "tips3":"2. Stellen Sie vor dem Senden sicher, dass Ihre Adresse und Ihr Netzwerk konsistent sind.",
    "tips4":"Wichtige Erinnerung: Aufgrund der Anonymität und Privatsphäre des Blockchain-Netzwerks verlieren Sie die entsprechenden Vermögenswerte, wenn Sie falsche Informationen eingeben. Bitte überprüfen Sie Ihre Versandadresse noch einmal.",
  },
  usdttb:{
    "title":"Abheben",
    "lmc":"Kettentyp",
    "xzl":"Kette auswählen",
    "xztbdz":"Abhebungsadresse auswählen",
    "qsrtbdz":"Bitte geben Sie die Abhebungsadresse ein",
    "tbdz":"Abhebungsadresse",
    "qsrdz":"Bitte geben Sie die Adresse ein",
    "tbsl":"Abhebungsbetrag",
    "tbsl2":"Abhebungsbetrag",
    "qsrtbsl":"Bitte geben Sie den Abhebungsbetrag ein",
    "sjtxje":"Tatsächlicher Abhebungsbetrag",
    "qsrsjtxje":"Bitte geben Sie den tatsächlichen Abhebungsbetrag ein",
    "dzje":"Kontobetrag",
    "jymm":"Transaktionspasswort",
    "qsrjymm":"Bitte geben Sie das Transaktionspasswort ein",
    "sxf":"Bearbeitungsgebühr",
    "qsrsxf":"Bitte geben Sie die Bearbeitungsgebühr ein",
    "dzsl":"Kontobetrag",
    "dzsl2":"Betrag des erhaltenen Kontos:",
    "qsrdzsl":"Bitte geben Sie den Kontobetrag ein",
    "wxts":"Erinnerung:",
    "mrzdtxcs":"Mindestauszahlungsbetrag jedes Mal:",
    "hxxf":"Muss verbraucht werden",
    "cktx":"Nur für Auszahlungen verfügbar",
    "ci":"Zeiten",
    "wddtxyq":"Auszahlungsvoraussetzungen nicht erfüllt",
    "tjcg":"Erfolgreiche Übermittlung, bitte warten Sie auf Überprüfung",
    "tips":"Sie können Münzen nur abheben, wenn Ihre eigene Rechenleistung größer als 1 T ist (außer bei der Rechenleistung erfahrener Mining-Maschinen) oder die Rechenleistung unter dem Dach größer als 50 T ist.",
    "dz":"Adresse",
    "qd":"OK",
    "zdtb":"Mindestauszahlung",
  },
  kefu: {
    "title":"Kundenservice kontaktieren",
    "zxkf":"Kundenservice",
    "fzcg":"Kopieren erfolgreich",
  },
  xgdlmm:{//Modify login password
    "title":"Anmeldepasswort ändern",
    "t1":"Aktuelles Anmeldepasswort",
    "t2":"Bitte geben Sie das aktuelle Anmeldepasswort ein",
    "t3":"Neues Passwort",
    "t4":"Bitte geben Sie 6-16 Ziffern und Buchstaben ein",
    "t5":"Passwort bestätigen",
    "t6":"Bitte geben Sie 6-16 Ziffern und Buchstaben ein",
    "t7":"Bestätigen",
    "t8":"Das Passwort stimmt nicht mit dem Bestätigungspasswort überein",
    "mm":"Passwort",
    "qsrmm":"Bitte geben Sie Ihr Passwort ein",
    "qqrmm":"Bitte bestätigen Sie Ihr Passwort",
    "qsrsjh":"Handynummer",
    "zc":"Registrieren",
    "mmts":"Passwortlänge 6-12 Zeichen",
  },
  sztxmm:{//Set withdrawal password
    "title":"Transaktionspasswort ändern",
    "wjtkmm":"Transaktionspasswort vergessen",
    "qsrjdlmm":"Bitte geben Sie das aktuelle Transaktionspasswort ein",
    "zh":"Konto",
    "qsryxhzsj":"Bitte geben Sie Ihre E-Mail-Adresse oder Handynummer ein",
    "t1":"Aktuelles Transaktionspasswort",
    "t2":"Neues Transaktionspasswort",
    "t3":"Bitte geben Sie das 6-stellige Transaktionspasswort ein",
    "t4":"Passwort bestätigen",
    "t5":"Transaktionspasswort vergessen?",
    "t6":"Bestätigen",
    "t7":"Das Passwort stimmt nicht mit dem Bestätigungspasswort überein",
    "t8":"Transaktionspasswort",
    "yzm":"Verifizierungscode",
    "qsryzm":"Bitte geben Sie den Verifizierungscode ein",
    "hqyzm":"Bestätigungscode abrufen",
  },
  record: {
    "cbjl":"Einzahlungsdatensatz",
    "tbjl":"Auszahlungsdatensatz",
    "status":"['Nicht überprüft', 'Bestanden', 'Abgelehnt']",
    "bhly":"Ablehnungsgrund",
    "ldz":"Adresse",
    "cjsj":"Erstellungszeit",
    "zzsj":"Übertragungszeit",
    "czl":"Aufladekette",
    "zrl":"Übertragungskette",
    "jyhx":"Transaktions-Hash",
  },
  yqm: {
    "wdyqlj":"Mein Einladungslink",
    "wdyqm":"Mein Einladungscode",
    "schbyq":"Postereinladung erstellen",
    "bctp":"Bild speichern",
    "qx":"Abbrechen",
    "fx":"Teilen",
    "yqm":"Einladungscode kopieren",
    "bcewmdxc":"QR-Code im Album speichern",
    "bcbd":"Lokal speichern",
  },
  "wdtd": {
    "title":"Mein Team",
    "td":"Team",
    "yqhy":"Freunde einladen",
    "ren":"Person",
    "wdtdzrs":"Die Gesamtzahl meines Teams",
    "uid":"UID:",
    "zh":"Konto:",
    "tdrs":"Teamgröße:",
    "zcsj":"Registrierungsdatum:",
  },
  "wdyj": {
    "title":"Meine Leistung",
    "wdyd":"Meine Generation",
    "dyj":"Leistung",
    "tdzyj":"Gesamtleistung des Teams",
    "uid":"UID:",
    "tdrs":"Teamgröße:",
    "yj":"Leistung:",
  },
  "zc": {
    "title":"Vermögenswerte",
    "zzczh":"Gesamtvermögenswert",
    "dh":"Tausch",
    "yczc":"Vermögenswerte ausgeblendet als 0",
    "xj":"Aktueller Preis",
    "zh":"Umgerechnet",
    "zcmx":"Vermögenswertdetails",
  },
  "duihuang": {
    "title":"Tausch",
    "hl":"Wechselkurs",
    "zf":"Zahlung",
    "qbdh":"Alle tauschen",
    "ky":"Verfügbar",
    "dd":"Erhalten",
    "ljdh":"Jetzt einlösen",
    "cont":"Wechselkurs ändert sich, abhängig vom tatsächlich erhaltenen Betrag",
    "yebz":"Unzureichendes Guthaben",
    "ksslbz":"Unzureichende Menge verfügbar",
    "qtxje":"Bitte geben Sie die Menge ein",
    "dhcg":"Tausch erfolgreich",
    "mrcg":"Kauf erfolgreich",
    "mccg":"verkauft erfolgreich",
    "wtcg":"Delegation erfolgreich",
    "ts":"Eingabeaufforderung",
    "btcmTips":"Gemäß den Smart-Contract-Einstellungen wird der GDCC-Austausch von USDT am 8. August 2023 beginnen.",
    "qx":"Abbrechen",
  },
  "sign": {
    "title":"Anmelden, um Münzen zu erhalten",
    "title2":"Tägliche Anmeldebelohnung",
    "title3":"Anmeldebelohnung",
    "qd":"Anmelden",
    "yqd":"Angemeldet",
    "hdgz":"Regeldetails",
    "qdjl":"Check-in-Aufzeichnung",
    "qdcg":"Erfolgreich angemeldet",
  },
  "langNew": {
    "wd":"Meine",
    "jd":"Ausleihe",
    "jghy":"Futures",
    "xbsg":"Kauf von Singapur-Währung",
    "sylx":"Leistungsart",
    "syts":"Verdiensttage",
    "rsy":"Tägliches Einkommen",
    "rsy2":"Tägliches Einkommen",
    "yjdts":"Anzahl der ausgeliehenen Tage",
    "jdsy":"Krediteinnahmen",
    "jdsy2":"Krediteinnahmen",
    "jdrq":"Kreditdatum",
    "qdsy":"Anmeldevorteile",
    "tgsy":"Werbevorteil",
    "sybl":"Gewinnquote",
    "sybl2":"Gewinnquote",
    "ljcy":"Jetzt beitreten",
    "zsy":"USDT-Gesamteinkommen",
    "jdrz":"Linkknoten",
    "jiedian":"Knoten",
    "qsrje":"Bitte geben Sie einen Knoten ein",
    "xyb":"Weiter",
    "zhye":"Kontostand",
    "dzye":"Adressstand",
    "zhyezh":"Kontostand (Äquivalent)",
    "zq":"Zeitraum:",
    "zq2":"Zeitraum",
    "jdsl":"Kreditbetrag",
    "yxbd":"E-Mail bestätigen",
    "qsryxzh":"Bitte geben Sie Ihr E-Mail-Konto ein",
    "yxgz":"Die eingegebene E-Mail-Adresse entspricht nicht den Regeln",
    "jxz":"In Bearbeitung",
    "ywc":"Abgeschlossen",
    "day":"Tage",
    "jg":"Preis",
    "zwsj":"Keine Daten~",
    "wyjb":"Ausleihen",
    "fxjl":"Belohnung teilen",
    "aqsz":"Sicherheitseinstellungen",
    "wded":"Meine zweite Generation",
    "wdsd":"Meine drei Generationen",
    "dbxe":"Limit für einzelne Transaktionen",
    "tjdd":"Bestellung abschicken",
    "tqsh":"Abheben Einlösung",
    "shuhui":"Einlösung",
    "ljdz":"Linkadresse",
    "yyqh":"Sprachumschaltung",
    "zxkf":"Kundenservice",
    "syl":"Tägliche Rendite",
    "zhuanbi":"Münzen verdienen",
    "zbsy":"Währungseinkommen verdienen",
    "mc":"Name",
    "zxj":"Aktueller Preis",
    "zfb":"Aufsteigende Liste",
    "shouye":"Homepage",
    "gg":"Annonce",
    "rzz":"Certification",
    "yrz":"Authentifié",
    "rzsb":"L'authentification a échoué, veuillez vous authentifier à nouveau",
    "cxrz":"Réauthentification",
    "jymmts":"Veuillez définir un mot de passe de transaction",
  },
  "xbsg":{
    "title":"Newcoin",
    "wdsg":"Détails",
    "scts":"Jours de blocage :",
    "sy":"Restant",
    "ljsg":"S'abonner maintenant",
    "ysk":"Épuisé",
    "xzjdy":"S'abonner maintenant",
    "dy":"S'abonner",
    "fxjg":"Prix d'émission",
    "fxl":"Circulation",
    "ssrq":"Date de cotation",
    "yxqx":"Période de validité",
    "qsrsl":"Veuillez saisir le montant",
    "syl":"Restant",
    "sgrq":"S'abonner",
    "sgsl":"Montant",
    "bz":"Pièce",
    "yebz":"Unzureichendes USDT-Guthaben",
    "tgsl":"Bestanden Menge",
    "shz":"Wird geprüft",
    "wtg":"Nicht bestanden",
    "ytg":"Bestanden",
  },
  "wydb":{
    "title":"Ausleihen",
    "db":"Ausleihen",
    "dbz":"Ausleihen",
    "jl":"Aufzeichnen",
    "jdzq":"Zeitraum (Tage)",
    "qhk":"Zur Rückzahlung",
    "ljdb":"Kumulativ (USDT)",
    "dhkbs" :"Ausstehende Zahlung",
    "jkje":"Darlehensbetrag (USDT)",
    "qsrje":"Bitte Betrag eingeben",
    "rll":"Täglicher Zinssatz",
    "hkfs":"Rückzahlung",
    "dqych":"Abgelaufen",
    "lx":"Zinsen",
    "fkjg":"Kreditgeber",
    "tpsc":"Kreditdarlehen (Bild hochladen)",
    "fwxx":"Wohnungsinformationen",
    "srzm":"Einkommensnachweis (Arbeitsverhältnis)",
    "yhmx":"Kontoauszug",
    "zjz":"Ausweisfoto",
    "yd":"Ich habe gelesen und stimme zu",
    "xy":"Kreditvertrag beantragen",
    "sqdb":"Klicken Sie hier, um Kreditketten zu beantragen",
    "gb":"Schließen",
    "qd":"OK",
    "ts":"Bitte aktivieren Sie „Kreditvertrag beantragen“",
    "dbjl":"Aufzeichnen",
    "hkhth":"Bestellcode",
    "wsh":"Nicht überprüft",
    "yfk":"Kredit",
    "sqrq":"Antragszeit",
    "zq":"Zyklus",
    "dbsl":"Anzahl der Rippen",
    "zhke":"Gesamtzahlung",
    "yhkxq":"Rückzahlungsdetails",
    "bqyhk":"Rückzahlbar im aktuellen Zeitraum (USDT)",
    "hktips":"Bitte stellen Sie sicher, dass das Guthaben ausreichend ist. Wenn das Guthaben nicht ausreicht, laden Sie bitte zuerst auf und zahlen Sie dann zurück",
    "bj":"Kapital",
    "jie":"Ausleihen",
    "ljhk":"Sofort zurückzahlen",
    "qcz":"Einzahlen",
    "yebzqxcz":"Unzureichendes Guthaben, bitte erst aufladen und dann zurückzahlen",
    "znj":"Gebühr für verspätete Zahlung",
    "yqts":"Tage überfällig",
  },
  "hkxq":{
    "dd":"Bestellen",
    "fzhkdz":"Rückzahlungsadresse kopieren",
    "hkxq":"Rückzahlungsdetails",
    "zlx":"Gesamtzinsen",
    "zhk":"Gesamtrückzahlungen",
    "hkjg":"Rückzahlungsagentur",
    "qschkpz":"Bitte laden Sie die Rückzahlungsbescheinigung hoch",
    "hkpz":"Rückzahlungsbescheinigung",
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"Bestellen",
    "cj":"Angebot",
    "jj":"Info",
    "sj":"Zeit",
    "fx":"Richtung",
    "jg":"Preis",
    "sl":"Menge",
    "mr":"Kaufen",
    "mc":"Verkaufen",
    "mp":"Gebot",
    "sp":"Verkauf",
    "slb":"Menge",
    "fhsj":"Ausgabedatum",
    "fhsl":"Ausgabenummer",
    "bps":"Whitepaper",
    "gw":"Offizielle Website",
    "fz":"Min",
    "xs":"Stunde",
    "tian":"Tage",
    "zhou":"Woche",
    "yue":"Monat",
    "gd":"Mehr",
    "ft":"Unterdiagramm",
    "zt":"Hauptdiagramm",
    "sdt":"Tiefenbild",
    "zx":"Favoriten",
    "djck":"Klicken, um anzuzeigen",
  },
  "jghy":{
    "jghy":"Optionen",
    "yxhy":"Dauerhaft",
    "mz":"Long kaufen",
    "md":"Short kaufen",
    "gmj":"Kaufpreis",
    "jsj":"Abrechnungspreis",
    "xj":"Aktueller Preis",
    "fx":"Richtung",
    "sl":"Volumen",
    "jgsj":"Lieferzeit",
    "gb":"Schließen",
    "jxxd":"Weiter zur Bestellung",
    "cclb":"Bestellliste",
    "zc":"Aktuell",
    "lscc":"Verlauf",
    "qblx":"Alle",
    "yk":"Gewinn",
    "ddqr":"Bestellbestätigung",
    "dqsj":"Ablaufzeit",
    "jssj":"Lieferzeit",
    "sy":"Gewinn",
    "tzje":"Investitionspreis",
    "zdje":"Niedrigster Preis 0",
    "kyye":"Guthaben",
    "kyye2":"Guthaben",
    "sxf":"Gebühr:",
    "sxfl":"Gebühr",
    "jypz":"Name",
    "jyfx":"Richtung",
    "qrxd":"Bestätigen",
    "fs":"Zeile",
    "dqye":"Aktueller Kontostand",
  },
  "zhjl":{
    "title":"Vermögensverlauf",
    "cbtb":"Einzahlung & Auszahlung",
    "jymx":"Transaktionsverlauf",
    "tgyj":"Aktionsprovision",
    "wwc":"Rückgängig gemacht",
    "ywc":"Abgeschlossen",
  },
  "tipsNew":{
    "wjmmts":"Passwort per Bestätigungscode wiederherstellen",
    "qscpztp":"Bitte laden Sie das Gutscheinbild hoch",
    "emailgsts":"Eingabepostfächer entsprechen nicht den Regeln",
    "telgsts":"Die Mobiltelefonnummer ist falsch",
    "lcmmbyz":"Bitte bestätigen Sie Ihr Passwort",
    "zdsl":"Mindestmenge",
    "sldydy":"Menge größer oder gleich",
    "zxtzsl":"Mindestmenge",
    "ddz":"Wartezeit",
    "xs":"Stunde",
    "min":"Mindestbetrag",
    "max":"Höchstbetrag",
    "yebz":"Unzureichendes Guthaben",
    "qsrss":"Bitte geben Sie Lots ein",
    "zdss":"Mindestlots",
    "yjj":"Abgelehnt",
    "shz":"Rücknahme",
    "zwkfcz":"Diese Währung ist nicht für Einzahlungen freigegeben",
    "jiaoge":"Lieferung",
    "zhang":"Long",
    "die":"Short",
  },
  "assets": {
    "total":"Vermögensumrechnung (USD)",
    "avaiable":"Verfügbar",
    "conversion":"Umrechnung",
    "canuse":"Verfügbar",
    "yczc":"Vermögenswerte als 0 ausgeblendet",
  },
  "status": {
    "statusText":"['Fehler','Warten','Erfolg']",
  },
  "langNew2":{
    "zczgz":"Gesamtvermögen",
    "hgx":"Compliance",
    "yszc":"Datenschutzrichtlinie",
    "gywm":"Über uns",
    "zb":"KI-Arbitrage",
    "mnjy":"Simulierter Handel",
    "xbzq":"Währungszone Singapur",
    "flzq":"Rewards Hub",
    "cjmnzhcg":"Demokonto erfolgreich erstellt!",
    "wdzh":"Mein Konto",
    "yymnzhts":"Sie haben bereits ein virtuelles Konto, bitte registrieren Sie sich nicht erneut",
    "tcmnzh":"Demokonto verlassen",
    "mnzhgz":"Demokontobewertung",
    "mnzh":"Demokonto",
    "ljdzsb":"Verbindung zur Adresse fehlgeschlagen",
    "ysq":"Autorisiert",
  },
  "c2c":{
    "bt":"C2C",
    "bt2":"C2C-Zahlungsdienst",
    "cjdd":"Bestellung erstellen",
    "mblc":"Einzahlung in Fiat-Währung",
    "cjydd":"Vorbestellung erstellen",
    "xmjfk":"An Verkäufer bezahlen",
    "tqhb":"Ihre digitale Währung abheben",
    "ddzt":"Bestellstatus",
    "wdys":"Unsere Vorteile",
    "c1":"Handeln Sie zu Ihrem Wunschpreis",
    "c2":"Kaufen und verkaufen Sie Kryptowährungen frei zu Ihrem Wunschpreis. Kaufen und verkaufen Sie aus bestehenden Angeboten oder erstellen Sie eine Handelsanzeige, um Ihren Wunschpreis festzulegen.",
    "c3":"Niedrige Transaktionsgebühr",
    "c4":"Peer-to-Peer-Transaktionen (C2C) ermöglichen es Verkäufern, die gewünschte Zahlungsmethode auf transparente Weise frei zu definieren und Kryptowährungen über mehr als 700 Zahlungsmethoden zu kaufen und zu verkaufen, darunter Banküberweisung und Bargeld.",
    "c5":"Mehrere Zahlungsmethoden",
    "c6":"Peer-to-Peer-Handel (C2C) ermöglicht es Verkäufern, die gewünschte Zahlungsmethode frei zu definieren. Kaufen und verkaufen Sie Kryptowährungen mit mehr als 700 Zahlungsmethoden, darunter Banküberweisung und Bargeld.",
    "wpp":"Nicht abgeglichen",
    "ypp":"Abgeglichen",
    "ysx":"Abgelaufen",
    "ddh":"Bestellnummer",
    "mrje":"Kaufbetrag",
    "mrbz":"Kaufwährung",
    "nssdgj":"Land",
    "qsrnssdgj":"Bitte geben Sie das Land ein",
    "fkrxm":"Name des Zahlers",
    "qsrfkrxm":"Bitte geben Sie den Namen des Zahlers ein",
    "yx":"E-Mail",
    "qsryx":"Bitte geben Sie Ihre E-Mail-Adresse ein",
    "mmbz":"Kaufart",
    "qxzmmbz":"Bitte wählen Sie die Kaufart aus",
    "qxz":"Bitte wählen Sie",
    "fkfs":"Zahlungsmethode",
    "qtxfkfs":"Bitte geben Sie die Zahlungsmethode ein",
    "zh":"Konto",
    "fb":"Zahlungswährung",
    "qtxfb":"Bitte geben Sie die Zahlungswährung ein",
    "ngmdje":"Betrag Ihres Einkaufs",
    "qsrje":"Bitte geben Sie den Betrag ein",
    "wxts":"Herzliche Erinnerung",
    "dsh":"Zu überprüfen",
    "ygq":"Abgelaufen",
    "jcwdwt":"Einführung in C2C",
    "tjpz":"Gutschein einreichen",
    "ckje":"Abgleichbetrag",
    "qsrckje":"Bitte geben Sie den entsprechenden Betrag ein",
    "tjzzfb":"Überweisungskopie",
    "tjjzzm":"Personalausweis (Vorderseite)",
    "tjjzfm":"Personalausweis (Rückseite)",
    "psts1":"Achten Sie beim Fotografieren auf folgende Punkte",
    "psts2":"Bitte beachten Sie, dass der Bildrand vollständig, die Schrift klar und die Helligkeit gleichmäßig ist",
    "psts3":"Bitte laden Sie keine Ausweisfotos hoch, die nicht mit Ihrem Namen übereinstimmen",
    "qsczzfb":"Bitte laden Sie eine Kopie der Überweisung hoch",
    "qscjzzm":"Bitte laden Sie die Vorderseite Ihres Führerscheins hoch",
    "qscjzfm":"Bitte laden Sie die Rückseite Ihres Führerscheins hoch",
    "tj":"Absenden",
    "je":"Bereich begrenzen",
    "ljtg":"Bestellung aufgeben",
    "sp":"DEFI verstehen",
    "xq":"Details",
    "lxkfppdd":"Kontaktieren Sie den Kundendienst, um die Bestellung abzugleichen",
    "szgj":"Land",
    "qsrszgj":"Bitte geben Sie Ihr Land ein",
    "fkyhmc":"Name der Zahlungsbank",
    "qsrfkyhmc":"Bitte geben Sie den Namen der Zahlungsbank ein",
    "dianhui":"Banküberweisung/Internationale Banküberweisung",
    "ccsr":"Hier eingeben",
  },
  "xyf":{
    "title":"Kreditscore",
    "pgsj":"Bewertungszeitpunkt",
  },
  "bbjy":{
    "mr":"Kaufen",
    "mc":"Verkaufen",
    "mai":"Ankauf",
    "sell":"Verkaufen",
    "xj":"Limit",
    "sj":"Markt",
    "pk":"Position",
    "jg":"Preis",
    "sl":"Menge",
    "ss":"Menge",
    "mrl":"Kaufvolumen",
    "mcl":"Verkaufsvolumen",
    "ky":"Verfügbar",
    "km":"Verfügbar",
    "ksell":"Marktfähig",
    "jye":"Umsatz",
    "dqwt":"Aktuelle Betrauung",
    "lswt":"Hierige Betrauung",
    "jj":"Info",
    "wtzl":"Gesamt",
    "wtjg":"Auftragspreis",
    "ycjl":"Abgeschlossenes Handelsvolumen",
    "cjjj":"Durchschnittlicher Transaktionspreis",
    "cd":"Bestellung stornieren",
    "xd":"Bestellung",
    "wqcj":"Ein abgeschlossener Deal",
    "ywc":"Abgeschlossen",
    "ycd":"Stornierte Bestellung",
    "zx":"Favoriten",
    "scjg":"Marktpreis",
    "fhsj":"Ausgabedatum",
    "fhsl":"Ausgabenummer",
    "bps":"Whitepaper",
    "gw":"Offizielle Website",
    "qx":"Stornieren",
    "bbjy":"Börse",
  },
  "hyjy":{
    "mai":"Kaufen",
    "sell":"Verkaufen",
    "kc":"Positionen eröffnen",
    "pc":"Positionen schließen",
    "cc":"Positionen",
    "kp":"Schließen",
    "kpc":"Short schließen",
    "kcc":"Positionen",
    "kkd":"Long eröffnen",
    "kpd":"Long schließen",
    "kkk":"Short eröffnen",
    "xj":"Limit",
    "sj":"Markt",
    "xjwt":"Limit-Bestellung",
    "sjwt":"Marktpreis",
    "pk":"Position",
    "jg":"Preis",
    "sl":"Menge",
    "gg":"Hebel",
    "tzgg":"Kontrollhebel",
    "ggbs":"Hebelwirkung",
    "mrl":"Kaufvolumen",
    "ky":"Verfügbar",
    "jye":"Umsatz",
    "dqwt":"Aktuelle Betrauungen",
    "lswt":"Historische Betrauungen",
    "ptwt":"Gewöhnliche Betrauungen",
    "dqwtmr":"Aktuelle Betrauungen (Kaufen)",
    "dqwtmc":"Aktuelle Betrauungen (Verkaufen)",
    "hywt":"Vertragsbetrauungen",
    "jj":"Info",
    "wtzl":"Gesamt",
    "wtjg":"Betrauungspreis",
    "ycjl":"Abgeschlossenes Handelsvolumen",
    "cjjj":"Durchschnittlicher Transaktionspreis",
    "qbcd":"Alle Aufträge zurückziehen",
    "cd":"Auftrag stornieren",
    "xd":"Auftrag",
    "wqcj":"Ein abgeschlossener Deal",
    "ywc":"Abgeschlossen",
    "ycd":"Stornierter Auftrag",
    "zx":"Favoriten",
    "scjg":"Marktpreis",
    "fhsj":"Ausgabedatum",
    "fhsl":"Ausgabenummer",
    "bps":"Whitepaper",
    "gw":"Offizielle Website",
    "mrzd":"Long Open",
    "mrpk":"Short Close",
    "mczk":"Short Open",
    "mcpd":"Long Close",
    "mrkdkz":"Long Open (bullisch)",
    "mrpkkz":"Short Close (bullisch)",
    "mckkkd":"Short Open (bearisch)",
    "mcpdkd":"Long Close (bearisch)",
    "yxhy":"Unbefristeter Vertrag",
    "dc":"Long-Positionen",
    "kcjj":"Durchschnittspreis offener Positionen (BUSDT)",
    "wsxyl":"Nicht realisierter Gewinn (BUSDT)",
    "ygqpj":"Geschätzte starke Parität (BUSDT)",
    "syl":"Tägliches Einkommen",
    "cwbzj":"Positionsmarge (BUSDT)",
    "cw":"Positionen (Nr.)",
    "cwjz":"Positionswert (BUSDT)",
    "bzjl":"Margin-Rate",
    "kpz":"Schlusskurs (Nr.)",
    "bdzs":"Basisindex",
    "tzbzj":"Marge anpassen",
    "zyzs":"Gewinn mitnehmen und Stop-Loss",
    "zjbzj":"Marge erhöhen",
    "jsbzj":"Marge reduzieren",
    "tyhy":"Erfahrungsvertrag",
    "ccz":"Position (Nr.)",
    "cwbzjt":"Positionsmarge (TBTC)",
    "zdzjbzj":"Maximale Margenerhöhung (TBTC)",
    "zjbzjt":"Margenerhöhung (TBTC)",
    "zhang":"Menge",
    "qblx":"Alle Typen",
    "qb":"Alle",
    "ccjg":"Positionspreis",
    "ccsl":"Positionsmenge",
    "yk":"Gewinn und Verlust",
    "ccsj":"Positionszeit",
    "zy":"Gewinn mitnehmen",
    "zs":"Stop-Loss",
    "zje":"Gesamtbetrag",
    "kcs":"Offene Positionen Menge",
    "kcjg":"Offene Positionen Preis",
    "ss":"Lots",
    "hand":"1 Lot =",
    "qx":"Abbrechen",
    "qr":"OK",
  },
  "bbjyNew":{
    "jylx":"Typen von",
    "jyze":"Betrag",
  },
  "langNew3":{
    "bzxq":"Details zum Verschieben von Bausteinen",
    "znbz":"KI Quantitative Intelligent Brick Moving",
    "apits":"Nahtlose Verbindung zu den APIs von über 200 Börsen auf der ganzen Welt",
    "jr":"Beitreten",
    "gn":"Funktion",
    "lhjs":"Einführung in die Dividendenquantifizierung",
    "jqrts":"Wie funktionieren Roboter?",
    "sctj":"Marktstatistiken",
    "scqk":"Marktbedingungen",
    "jiaoge":"Lieferung",
    "zhang":"Anstieg",
    "die":"Fall",
    "sz":"Einstellungen",
    "qbcp":"Alle Produkte",
    "jrlh":"KI-Quantifizierung beitreten",
    "sywd":"0 Risiko, stabile Renditen",
    "bzbz":"Kryptotyp",
  },
  "sztkmm":{
    "title":"Auszahlungspasswort festlegen",
    "dlmm":"Anmeldepasswort",
    "dlmmts":"Bitte geben Sie das Anmeldepasswort ein",
    "xmm":"Neues Passwort",
    "mmts":"Passwortlänge 6 Ziffern",
    "qrmm":"Passwort bestätigen",
    "qr":"OK",
    "qd":"OK",
    "sztkts":"Tipp: Bitte gehen Sie zum Sicherheitscenter, um das Transaktionskennwort festzulegen",
  },
  "bzhl":{
    "title":"Dividende",
    "gz":"Regeln",
    "tgdd":"Treuhandauftrag",
    "zztgdzj":"Verwahrte Gelder",
    "yjjrsy":"Täglich geschätzt",
    "ljsy":"Gesamteinkommen",
    "tgzdd":"Verwahrte Bestellung",
    "cljxcp":"Strategische Kampagnenprodukte",
    "dbxe":"Limit",
    "rsyl":"Tägliche Rendite",
    "zq":"Bestellzyklus",
    "qmr":"Los und kaufen",
    "bbzhzc":"Kontovermögen",
    "zcc":"Gesamtvermögen (USDT)",
    "dd":"Bestellungen",
    "buy":"Kaufen in",
    "jxcp":"Ausgewählte Produkte",
    "ckdd":"Bestellung prüfen",
    "gd":"Mehr",
    "xzbzts":"Einfach und sicher. Dividenden können in mehreren Währungen ausgewählt werden",
    "qtbz":"Andere Münzen",
    "dj":"Level",
    "cjwt":"Häufige Probleme",
    "ddsl":"Bestellmenge",
    "sl":"Betrag",
  },
  "bzhlgm":{
    "title":"Gewinne aus Ziegelentfernung",
    "bzhld":"Gewinne aus Ziegelentfernung USDT",
    "qtzq":"USDT 7-Tage-Zyklus",
    "rsyl":"Tägliche Rendite",
    "lczq":"Finanzzyklus",
    "dbxe":"Limit",
    "pxsj":"Dividendenauszahlungszeitpunkt",
    "mr":"Täglich",
    "dqfh":"Rückzahlung bei Fälligkeit",
    "tgzj":"Depotkapital",
    "tqsh":"Vorzeitige Rückzahlung",
    "yjsy":"Erwartetes Einkommen (USDT)",
    "kyzc":"Verfügbares Vermögen (USDT)",
    "cpjs":"Über unsere Produkte",
    "tgje":"Betrag eingeben",
    "qsrtgje":"Bitte geben Sie den Depotbetrag ein",
    "qb":"Alle",
    "rm":"Klicken Sie hier",
    "cpzq":"Produktzyklus",
    "jxr":"Zinsberechnungsdatum",
    "jiexr":"Zinsabrechnungsdatum",
    "yjdzr":"Voraussichtliches Ankunftsdatum",
    "gz":"Kennen Sie die Regeln und Zinsen",
  },
  "bzhlwdtg":{
    "title":"Bestellstatus",
    "tgz":"In Verwahrung",
    "ywc":"Abgeschlossen",
    "ysh":"Eingelöst",
    "tgje":"Verwahrungsbetrag/Verwahrungszeit",
    "rsyl":"Tägliche Rendite",
    "yhl":"Gewinn",
    "xdsj":"Bestellzeit",
    "sh":"Einlösung",
    "ddxq":"Bestelldetails",
    "ddh":"Bestellnr.",
    "syts":"Verbleibend",
    "ddztxq":"Bestellstatusdetails",
  },
  "langNew4":{
    "kp":"Eröffnungskurs",
    "zuoshou":"Gestern erhalten",
    "zg":"Höchstkurs",
    "zd":"Tiefstkurs",
    "dqjg":"Aktueller Kurs",
    "pcjg":"Schlusskurs",
    "gd":"Ausstehender Auftrag",
    "gdj":"Ausstehender Auftragskurs",
    "gdjg":"Ausstehender Auftragskurs",
    "xfbzj":"Sicherheitsleistung erforderlich",
    "ksrfw":"Verfügbarer Eingabebereich",
    "shou":"Lots",
    "fdjyk":"Floating Nettogewinn und -verlust",
    "pcsl":"Schlussmenge",
    "cx":"widerrufen",
    "qrpc":"Bestätigen, um die Position zu schließen",
    "sx":"Filter",
    "cz":"Zurücksetzen",
    "zdl":"Wusste",
    "kccg":"Position erfolgreich eröffnet!",
    "xzfx":"Richtung wählen",
    "lx":"Typ",
    "xgcc":"Position ändern",
    "szzyzs":"Stop-Profit und Stop-Loss festlegen",
    "szhb":"Krypto",
    "gjs":"Metall",
    "yy":"Rohöl",
    "jy":"Handel",
    "jmhb":"Krypto",
    "gdsj":"Zeit der ausstehenden Order",
    "gdsl":"Menge der ausstehenden Order",
    "fs":"Zeit",
   },
   "deals": {
  	"issue_time":"Zeit",
    "issue_number":"Nummer",
    "white_book":"Buch",
    "weburl":"URL",
    "video_url":"Video",
    "introduction":"Info",
    "onhand":"eine Hand gleich",
    "position":"Position",
    "leverorder":"Hebelaufträge",
    "leverposition":"Hebelposition",
    "inputprice":"Preis eingeben",
    "inputmul":"Vielfaches eingeben",
    "selectmul":"Vielfaches wählen",
    "onehand":"eine Hand gleich",
    "hand":"Anzahl der Handelshände",
    "marketval":"Marktwert",
    "bond":"Anleihe",
    "service":"Servicegebühr",
    "balance":"Guthaben",
    "type":"Typ",
    "risk":"Risikorate",
    "total":"Gesamtgewinn",
    "onekey":"Schließung",
    "makemore":"(Long)",
    "makeless":"(Short)",
    "current":"Offene Aufträge",
    "all":"Alle",
    "weing":"In Kommission",
    "tding":"Handel",
    "ping":"Schließung",
    "pied":"Geschlossen",
    "ceiled":"Abgehoben",
    "weprice":"Provisionspreis",
    "oprice":"Eröffnungspreis",
    "nowprice":"Aktueller Preis",
    "zyprice":"Stop-Gewinnpreis",
    "zsprice":"Stop-Loss-Preis",
    "canbond":"Verfügbare Marge",
    "optime":"Eröffnungszeit",
    "pgtime":"Schließungszeit",
    "znum":"Umgerechnete Menge",
    "gprice":"Übernachtgebühren",
    "pcang":"Schließen",
    "revoke":"Abhebung",
    "fee":"Gebühr",
    "you":"Optimaler Marktpreis",
  },
  "zyzs":{
    "title":"Take Profit & Stop Loss",
    "zy":"Take Profit",
    "zs":"Stop Loss",
    "qsrzyjg":"Bitte geben Sie einen Take Profit-Preis ein",
    "qsrzsjg":"Bitte geben Sie einen Stop Loss-Preis ein",
    "cfjglx":"Trigger-Preistyp",
    "zsjg":"Indexpreis",
    "scjg":"Marktpreis",
    "pcfs":"Methoden zum Schließen von Positionen",
    "kpcw":"Closeout",
    "qbcw":"Alle Positionen",
    "wxts":"Bitte beachten",
    "cont":"Das Schließen von Positionen zum Marktpreis kann dazu führen, dass eine Bestellung zum Marktpreis nicht erfolgreich aufgegeben werden kann oder dass aufgrund starker Marktschwankungen und anderer Probleme keine erfolgreiche Gewinnmitnahme/Stop Loss möglich ist.",
    "qr":"OK",
  },
  "level1": {
    "name":"Echter Name",
    "idcard":"Zertifikatstyp",
    "address":"Aktuelle Wohnadresse",
    "bank_number":"Bankleitzahl",
    "wc":"OK",
    "name_nodata":"Der Name darf nicht leer sein",
    "id_card_nodata":"Die Zertifikatsnummer darf nicht leer sein",
    "address_nodata":"Die Adresse darf nicht leer sein",
    "bank_number_nodata":"Bankkartennummer darf nicht leer sein",
    "input-username":"Bitte geben Sie Ihren richtigen Namen ein",
    "zjhm":"Zertifikatsnummer",
    "input-idcard":"Bitte geben Sie Ihre Zertifikatsnummer ein",
    "input-address":"Bitte geben Sie Ihre Adresse ein",
    "zjlx":"Arten gültiger Ausweise",
    "qxzzjlx":"Bitte wählen Sie Arten gültiger Ausweise aus",
    "sfz":"Personalausweis",
    "hz":"Reisepass",
    "jsz":"Führerschein",
    "lxz":"Zertifikat für Auslandsstudium",
    "zfbzh":"Alipay-Konto",
    "qsrzfbzh":"Bitte geben Sie Ihr Alipay-Konto ein",
    "khh":"Kontoeröffnung",
    "qsrkhh":"Bitte geben Sie Ihre Kontobank ein",
    "yhkh":"Bankkartennummer",
    "qsryhkh":"Bitte geben Sie Ihre Bankkartennummer ein.",
    "zfzh":"Zahlungskonto",
    "qxzzfzh":"Bitte wählen Sie ein Zahlungskonto.",
    "gjlb":"Länderliste",
    "qxzgjlb":"Bitte wählen Sie ein Land/eine Region.",
    "gjhdq":"Land/Region",
    "qtxgj":"Bitte geben Sie das Land/die Region ein.",
  },
  "gjrz":{
    "title":"KYC-Authentifizierung",
    "t1":"1. Bilder mit weniger als 8 MB und in den Formaten JPG, JPEG oder PNG werden unterstützt.",
    "t2":"2. Fotos auf Ausweisdokumenten müssen klar sein und dürfen nicht verändert oder blockiert werden. Das persönliche Foto, die Dokumentennummer und der Name des Dokumenteninhabers müssen deutlich sichtbar sein.",
    "t3":"3. Die Fotos müssen ohne Kopfbedeckung aufgenommen werden und es wird empfohlen, kein Make-up zu verwenden. Die Gesichtszüge des Dokumenteninhabers sollten klar und erkennbar sein und seine Arme sollten vollständig freigelegt sein.",
    "t4":"OK",
    "bh":"Ablehnen",
    "shz":"Wird geprüft",
    "shtg":"Genehmigt",
    "nyrzcg":"Sie wurden erfolgreich zertifiziert",
    "sczjz":"ID-Fotos hochladen",
    "sczjzmz":"Foto der Vorderseite des Ausweisdokuments hochladen",
    "sczjbmz":"Foto der Rückseite des Ausweisdokuments hochladen",
    "scgrqmz":"Dokumente und persönliche Unterschrift hochladen",
    "wdtjr":"Mein Empfehlungsgeber",
    "tjrid":"Empfehlungsgeber-ID",
    "qsrtjrid":"Bitte geben Sie die Empfehlungsgeber-ID ein",
    "idbcz":"Empfehlungs-ID existiert nicht",
    "tjcg":"Absenden erfolgreich",
    "tjridts":"Die Empfehlungs-ID kann nicht von Ihnen selbst ausgefüllt werden",
    "qsrzh":"Bitte geben Sie das Konto ein",
    "dl":"Anmelden",
    "jc":"Schlecht",
    "yb":"Allgemein",
    "yx":"Ausgezeichnet",
    "ldjsqh":"LME Futures",
    "wh":"Devisen",
  },
  "newReg":{
    "sjh":"Mobil",
    "yx":"E-Mail",
    "yqm":"Einladungscode",
    "yqm2":"Einladungscode (optional)",
    "cjzh":"Konto erstellen",
    "sysjhzyx":"Mit Mobilnummer/E-Mail registrieren",
    "sj":"Mobil",
    "yhxy":"",
    "yhxy2":"Ich habe die  und   gelesen und stimme ihnen zu",
    "hmyzh":"Sie haben noch kein Konto?",
    "qzc":"Registrieren",
    "qbdl":"Wallet-Anmeldung",
    "qyqbfw":"Bitte verwenden Sie die Wallet-App für den Zugriff",
    "dc":"Abmelden",
    "cycs":"Anzahl der Teilnahmen"
  },
}



// WEBPACK FOOTER //
// ./src/utils/lang/de.js